import { TlfContextProps } from "./interface";

/**
 * Triggers deferred ARS hierarchy updates and clears the delayed-update flag.
 *
 * @param state - Current TLF context state.
 * @returns Updated state with the apply trigger incremented.
 */
export const tlf_applyArsUpdates = (state: TlfContextProps): TlfContextProps => {
  const newState = { ...state };

  newState.applyDelayedHierarchyUpdatesTrigger = state.applyDelayedHierarchyUpdatesTrigger + 1;
  newState.delayedHierarchyUpdates = false;

  return newState;
};
